export const HOUR_PERIOD_FORMAT = 'h:mm A';
